import { createReducer, on } from '@ngrx/store';
import * as Actions from './actions';
import * as RootActions from '../../actions';
import {
  AgGridColumnFilter,
  AgGridColumnSort,
  LicenceDto, LicenceFromStoreOrderRowDto,
  LicenceFromStoreOrderVehicleDto,
  LicenceProductCodeDto,
  VehicleLicencesDto,
} from '@services/api/api.service';

export interface State {
  dataTrafficLicences: {
    data: VehicleLicencesDto[];
    totalCount: number;
    isLoading: boolean;
    allData: VehicleLicencesDto[];
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
  storeOrderLicences: {
    data: LicenceFromStoreOrderVehicleDto[];
    totalCount: number;
    isLoading: boolean;
    allData: LicenceFromStoreOrderVehicleDto[];
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      productCode?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
  licenceProductCodes: {
    data: LicenceProductCodeDto[];
    isLoading: boolean;
  };
  selectedDataTrafficLicence: {
    vin: string;
    data: LicenceDto[];
    totalCount: number;
    isLoading: boolean;
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
  selectedStoreOrderLicence: {
    vin: string;
    data: LicenceFromStoreOrderRowDto[];
    totalCount: number;
    isLoading: boolean;
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
}


export const initialState: State = {
  dataTrafficLicences: {
    data: [],
    totalCount: 0,
    isLoading: false,
    allData: [],
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
    },
  },
  storeOrderLicences: {
    data: [],
    totalCount: 0,
    isLoading: false,
    allData: [],
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
      productCode: 'ALL',
    },
  },
  licenceProductCodes: {
    data: [],
    isLoading: false,
  },
  selectedDataTrafficLicence: {
    vin: '',
    data: [],
    totalCount: 0,
    isLoading: false,
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
    },
  },
  selectedStoreOrderLicence: {
    vin: '',
    data: [],
    totalCount: 0,
    isLoading: false,
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
    },
  },
};

export const selectDataTrafficLicences = state => state.licence.dataTrafficLicences;
export const selectStoreOrderLicences = state => state.licence.storeOrderLicences;
export const selectSelectedDataTrafficLicence = state => state.licence.selectedDataTrafficLicence;
export const selectSelectedStoreOrderLicence = state => state.licence.selectedStoreOrderLicence;
export const selectLicenceProductCodes = state => state.licence.licenceProductCodes;


export const licencesReducer = createReducer(
  initialState,
  on(RootActions.resetState, () => ({ ...initialState })),
  on(Actions.setDataTrafficLicencesLoading, (state, { isLoading }) => ({
    ...state,
    dataTrafficLicences: {
      ...state.dataTrafficLicences,
      isLoading,
    },
  })),
  on(Actions.setDataTrafficLicencesFilters, (state, { filters }) => ({
    ...state,
    dataTrafficLicences: {
      ...state.dataTrafficLicences,
      filters: {
        ...state.dataTrafficLicences.filters,
        ...filters,
      },
    },
  })),
  on(Actions.setDataTrafficLicencesPaginator, (state, { paginator }) => ({
    ...state,
    dataTrafficLicences: {
      ...state.dataTrafficLicences,
      paginator,
    },
  })),
  on(Actions.setDataTrafficLicencesList, (state, { response, totalNumber }) => ({
    ...state,
    dataTrafficLicences: {
      ...state.dataTrafficLicences,
      data: response,
      totalCount: totalNumber,
    },
  })),
  on(Actions.setDataTrafficLicencesAllData, (state, { allData }) => ({
    ...state,
    dataTrafficLicences: {
      ...state.dataTrafficLicences,
      allData,
    },
  })),
  on(Actions.setStoreOrderLicencesLoading, (state, { isLoading }) => ({
    ...state,
    storeOrderLicences: {
      ...state.storeOrderLicences,
      isLoading,
    },
  })),
  on(Actions.setStoreOrderLicencesFilters, (state, { filters }) => ({
    ...state,
    storeOrderLicences: {
      ...state.storeOrderLicences,
      filters: {
        ...state.storeOrderLicences.filters,
        ...filters,
      },
    },
  })),
  on(Actions.setStoreOrderLicencesPaginator, (state, { paginator }) => ({
    ...state,
    storeOrderLicences: {
      ...state.storeOrderLicences,
      paginator,
    },
  })),
  on(Actions.setStoreOrderLicencesList, (state, { response, totalNumber }) => ({
    ...state,
    storeOrderLicences: {
      ...state.storeOrderLicences,
      data: response,
      totalCount: totalNumber,
    },
  })),
  on(Actions.setStoreOrderLicencesAllData, (state, { allData }) => ({
    ...state,
    storeOrderLicences: {
      ...state.storeOrderLicences,
      allData,
    },
  })),
  on(Actions.setSelectedDataTrafficLicenceLoading, (state, { isLoading }) => ({
    ...state,
    selectedDataTrafficLicence: {
      ...state.selectedDataTrafficLicence,
      isLoading,
    },
  })),
  on(Actions.setSelectedDataTrafficLicenceFilters, (state, { filters }) => ({
    ...state,
    selectedDataTrafficLicence: {
      ...state.selectedDataTrafficLicence,
      filters: {
        ...state.selectedDataTrafficLicence.filters,
        ...filters,
      },
    },
  })),
  on(Actions.setSelectedDataTrafficLicencePaginator, (state, { paginator }) => ({
    ...state,
    selectedDataTrafficLicence: {
      ...state.selectedDataTrafficLicence,
      paginator,
    },
  })),
  on(Actions.setSelectedDataTrafficLicenceList, (state, { response }) => ({
    ...state,
    selectedDataTrafficLicence: {
      ...state.selectedDataTrafficLicence,
      data: response,
      totalCount: response.length,
    },
  })),
  on(Actions.getSelectedDataTrafficLicenceList, (state, { vin }) => ({
    ...state,
    selectedDataTrafficLicence: {
      ...state.selectedDataTrafficLicence,
      vin,
    },
  })),
  on(Actions.setSelectedStoreOrderLicenceLoading, (state, { isLoading }) => ({
    ...state,
    selectedStoreOrderLicence: {
      ...state.selectedStoreOrderLicence,
      isLoading,
    },
  })),
  on(Actions.setSelectedStoreOrderLicenceFilters, (state, { filters }) => ({
    ...state,
    selectedStoreOrderLicence: {
      ...state.selectedStoreOrderLicence,
      filters: {
        ...state.selectedStoreOrderLicence.filters,
        ...filters,
      },
    },
  })),
  on(Actions.setSelectedStoreOrderLicencePaginator, (state, { paginator }) => ({
    ...state,
    selectedStoreOrderLicence: {
      ...state.selectedStoreOrderLicence,
      paginator,
    },
  })),
  on(Actions.setSelectedStoreOrderLicenceList, (state, { response }) => ({
    ...state,
    selectedStoreOrderLicence: {
      ...state.selectedStoreOrderLicence,
      data: response.licences ?? [],
      totalCount: response.licences?.length ?? 0,
    },
  })),
  on(Actions.getSelectedStoreOrderLicenceList, (state, { vin }) => ({
    ...state,
    selectedStoreOrderLicence: {
      ...state.selectedStoreOrderLicence,
      vin,
    },
  })),
  on(Actions.setLicenceProductCodesLoading, (state, { isLoading }) => ({
    ...state,
    licenceProductCodes: {
      ...state.licenceProductCodes,
      isLoading,
    },
  })),
  on(Actions.setLicenceProductCodesList, (state, { productCodes }) => ({
    ...state,
    licenceProductCodes: {
      ...state.licenceProductCodes,
      data: productCodes,
    },
  })),
);


